$button-width: 50px;
$sidebar-width: 370px;
$sidebar-width-m: 430px;
$sidebar-width-xl: 500px;
$sidebar-height: 350px;
$max-sidebar-width: calc(100% - 5px);

.ux-iws-sidebar {
    display: block;
    position: fixed;
    top: calc(50% - $sidebar-height/2);
    left: calc(100% - $button-width);
    max-width: $max-sidebar-width;
    width: $sidebar-width;
    z-index: 999; // Exactly like old sidebar
    transition: left $animationSpeed-normal $animationEasing-ease;

    @media only screen and (min-width: 768px) {
        width: $sidebar-width-m;
    }

    @media only screen and (min-width: 1440px) {
        width: $sidebar-width-xl;
    }

    &__content {
        position: relative;
        z-index: 1;
        display: flex;
    }

    &__toggler-container {
        width: $button-width;
        transition: width $animationSpeed-normal $animationEasing-ease;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-end;
    }

    &__toggler-container .ux-button {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        left: 30px;
        min-width: $button-width;
        padding: 0;
        color: $color-white !important;
        background-color: $color-green !important;

        ux-icon {
            font-size: 30px;
            padding: 8px;
        }

        &:not(:last-of-type) {
            margin-bottom: 2px;
        }

        span {
            display: block;
            white-space: nowrap;
            width: 0;
            padding-right: 0;
            overflow: hidden;
            transition: width $animationSpeed-normal $animationEasing-ease,
                margin $animationSpeed-normal $animationEasing-ease;
        }
    }

    &--active .ux-iws-sidebar__active-toggler span {
        width: 0 !important;
        margin-right: 0 !important;
    }

    &__toggler-container .ux-button:hover span {
        @media only screen and (min-width: 1024px) {
            margin-right: 10px;
        }
    }

    &__toggler-wrapper {
        width: $button-width;
        margin-right: 2px;
    }

    &__sidebar-content {
        position: relative;
        width: calc(100% - $button-width);
        background-color: $color-white;
        z-index: 1;
        padding: 10px 10px 10px 20px;
        max-height: calc(100vh - (50vh - $sidebar-height/2) - 30px);
    }

    &__tab-wrapper {
        height: 100%;
        padding-right: 10px;
        overflow-y: auto;
    }

    &__content-shadow {
        position: absolute;
        width: 100%;
        left: 0;
        height: 25px;
        z-index: 1;

        &--top {
            top: 0;
            background: linear-gradient(
                to top,
                transparentize($color-white, 0.9999),
                $color-white 80%
            );
        }

        &--bottom {
            bottom: 0;
            background: linear-gradient(
                to bottom,
                transparentize($color-white, 0.9999),
                $color-white 80%
            );
        }
    }

    &--active &__active-toggler.ux-button {
        color: $color-green !important;
        background-color: $color-white !important;
    }

    &--active {
        left: calc(100% - min($sidebar-width, $max-sidebar-width));

        @media only screen and (min-width: 768px) {
            left: calc(100% - min($sidebar-width-m, $max-sidebar-width));
        }

        @media only screen and (min-width: 1440px) {
            left: calc(100% - min($sidebar-width-xl, $max-sidebar-width));
        }
    }
}
